import Axios from 'axios'

const BASE_URL_END_POINT = '/discounts'

export const compareHierarchies = async (file) => {
  const formData = new FormData()
  formData.append('hierarchies', file, file.name)
  const response = await Axios.post(`${BASE_URL_END_POINT}/compareHierarchies`, formData, {
    timeout: 300000,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}
